import { Dayjs } from 'dayjs';

import { dayjs } from './dayjs-utils';

/**
 * Helper function for react-final-form validators
 * @param validators
 */
export const composeValidators =
    (...validators: any[]) =>
    (value: any) =>
        validators.reduce(
            (error, validator) => error || validator(value),
            undefined,
        );

/**
 * Check for a required value
 * @param value
 */
export const required = (value: any) => (value ? undefined : 'Required');

/**
 * Check for valid array
 * @param value
 */
export const requiredArray = (value: unknown) => {
    return Array.isArray(value) && value.length > 0 ? undefined : 'Required';
};

/**
 * Check for a valid Name
 * @param value
 */
export const mustBeName = (value: string) => {
    return /^[\p{L}\p{M}\p{Pd}'\u2019 ]*$/u.test(value)
        ? undefined
        : 'Names can only contain letters, spaces and dashes';
};

export const mustBeBetweenValues = (
    value: string,
    min: number,
    max: number,
) => {
    if (Number(value) < min || Number(value) > max) {
        return `Value must be between ${min} and ${max}`;
    }

    return undefined;
};

export const mustBeBetweenTimes = (
    min: number,
    max: number,
    value?: string,
) => {
    if (!value) return 'Required';

    const time = dayjs(value, 'HH:mm').utc(true);
    if (!time.isValid()) {
        return 'Invalid time';
    }

    const hour = time.hour();
    if (hour < min || hour > max) {
        return `Time must be between ${min}:00 and ${max}:00`;
    }

    return undefined;
};

export const mustBeBetweenDates = (
    min: Dayjs,
    max: Dayjs | undefined,
    value?: Dayjs,
) => {
    if (!value) return 'Required';

    const date = dayjs(value).utc(true);
    if (!date.isValid()) return 'Invalid date';

    if (min && date.isBefore(min, 'day')) {
        return `Date must be on or after ${min.format('DD/MM/YYYY')}`;
    }

    if (max && date.isAfter(max, 'day')) {
        return `Date must be on or before ${max.format('DD/MM/YYYY')}`;
    }

    return undefined;
};
